import React, { useRef, useEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { S3_IMAGES_URL } from '../../../../constants';

import { motion, useInView, useAnimation } from 'framer-motion';

type Props = { className?: string };

const OrbitOne = ({ className }: Props) => {
  const ref = useRef(null);
  const inViewport = useInView(ref);
  const control = useAnimation();
  const { isDesktop } = useLayoutContext();

  const variants = {
    initial: isDesktop
      ? { opacity: 0, scale: 0 }
      : { opacity: 0, scale: 0, left: '50%', right: '50%', x: '-50%', y: '-1%' },
    animate: isDesktop
      ? {
          opacity: 0.7,
          scale: 1,
          transition: { duration: 0.28 },
        }
      : {
          opacity: 0.7,
          scale: 0.7,
          rotate: 15,
          transition: { duration: 0.28 },
        },
  };

  useEffect(() => {
    if (inViewport) {
      control.start('animate');
    }
  }, [control, inViewport, isDesktop]);

  return (
    <motion.svg
      ref={ref}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="393"
      height="167"
      fill="none"
      variants={variants}
      initial="initial"
      animate={control}
    >
      <path
        id="orbitOne"
        stroke="url(#a)"
        strokeWidth="2"
        shapeRendering="geometricPrecision"
        d="M391.378 135.744c-2.316 8.643-9.874 15.528-21.745 20.528-11.863 4.997-27.948 8.072-47.139 9.141-38.377 2.139-89.057-3.75-142.935-18.186C125.681 132.79 78.847 112.55 46.68 91.509 30.595 80.989 18.203 70.282 10.427 60.023 2.647 49.758-.457 40.016 1.859 31.373c2.316-8.643 9.874-15.528 21.745-20.528 11.864-4.997 27.949-8.072 47.14-9.14C109.12-.436 159.8 5.454 213.678 19.89c53.878 14.436 100.713 34.677 132.879 55.717 16.085 10.521 28.478 21.227 36.253 31.486 7.781 10.266 10.884 20.007 8.568 28.65Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="354.464"
          x2="77.023"
          y1="12.65"
          y2="156.246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED7F1" />
          <stop offset=".085" stopColor="#FEFCFE" />
          <stop offset=".192" stopColor="#DBC1D4" />
          <stop offset=".285" stopColor="#6DD2E5" />
          <stop offset=".4" stopColor="#7BA0EB" />
          <stop offset=".51" stopColor="#BC86F6" />
          <stop offset=".632" stopColor="#DCC4F8" />
          <stop offset=".747" stopColor="#BFB5C6" />
          <stop offset=".87" stopColor="#F5F4F6" />
          <stop offset="1" stopColor="#D7CACE" />
        </linearGradient>
      </defs>
      <image
        href={`${S3_IMAGES_URL}planets_for_orbits/planet-1@2x.png`}
        width="50"
        height="50"
        y="45"
      >
        <mpath href="#orbitOne" />
      </image>
    </motion.svg>
  );
};

export default OrbitOne;
